export default __webpack_public_path__ + "static/media/icon-down-small-white.56e18ad5.svg";